<template>
  <div class="ml-0 align-left justify-space-around">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="openDialog()"
        >
          mdi-image-edit
        </v-icon>
      </template>
      <span>Agregar o Editar Imagen</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :width="$vuetify.breakpoint.lgAndUp ? 705 : 500"
    > 
      <v-card
        color="white"
        light
        class="mx-auto"
        :max-width="$vuetify.breakpoint.lgAndUp ? 700 : 480"
        :width="$vuetify.breakpoint.lgAndUp ? 700 : 480"
        outlined
      >
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            <v-img contain :src="`${domoapi2_img}cia/1/logo`" id="Home" width="154"></v-img>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="font-weight-medium">{{ codigo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" :loading="loading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
  
        <v-card>
          <v-tabs color="primary">
            <v-tab>Principal</v-tab>
            <v-tab>Galeria</v-tab>

            <v-tab-item>
              <v-container>
              <v-row>
                <v-col cols="6" offset="3">
                  <LoadImg
                    :titulo="titulo"
                    :tipo="tipo"
                    :codigo="codigo"
                    :categoria="categoria"
                    archivo="" />
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item>
              <v-card
                class="overflow-y-auto"
                max-height="330"
              >
                <v-container fluid>
                  <v-row>
                    <v-col
                      v-for="img in galeria"
                      :key="img.archivo"
                      cols="12"
                      md="4"
                    >
                      <LoadImg
                        :titulo="img.archivo"
                        :tipo="tipo"
                        :codigo="codigo"
                        categoria="Galeria"
                        :archivo="img.archivo"
                        @galeria="getGaleria" />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <LoadImg
                        titulo="Nueva"
                        :tipo="tipo"
                        :codigo="codigo"
                        categoria="Galeria"
                        archivo="0.jpg"
                        @galeria="getGaleria" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#B71C1C" dark @click="dialog = false" :loading="loading">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
  import { mapMutations, mapActions, mapState } from "vuex";
  import LoadImg from "./Domoapi2LoadImg";
  import axios from "axios";

  export default {
    components: {
      LoadImg
    },
    data() {
      return {
        dialog: false,
        FILE: null,
        loading: false,
        updateImg: Math.floor(Math.random() * 100),
        galeria: []
      }
    },
    props: {
      titulo: String,
      tipo: String,
      codigo: String,
      categoria: String,
    },
    methods: {
      async openDialog() {
        const resp = await axios.post(`${this.domoapi2_img}Datos`, {
          tipo: this.tipo,
          codigo: this.checkCodigo,
          categoria: "Galeria",
          archivo: ""
        });
        if (resp.status === 200) {
          const { data } = resp
          this.galeria = data;
        };
        
        this.dialog = true;
      },
      getGaleria(datos) {
        this.galeria = datos;
      },
      ChrEsp(chr) {
        const chrSplit = chr.split("")
        let newChr = ""

        chrSplit.forEach(x => {
          if (x === "/") newChr += "-"
          else if (x === ".") newChr += "-"
          else newChr += x
        })

        return newChr
      }
    },
    computed: {
      ...mapState(["domoapi2_img"]),
      checkCodigo() {
        return this.ChrEsp(this.codigo)
      },
    }
  }
</script>